import {
    MenuItemProps,
    useRuntimeEnvRolesIncludes,
    useTranslations,
    useUrlParamsValueToString,
} from "@bsm/component";

export const useInvoiceViewerMenu = (): Array<MenuItemProps> => {
    const [
        FAMILY
    ] = useTranslations(i18n);
    const rolesInclude = useRuntimeEnvRolesIncludes();
    const urlParams = useUrlParamsValueToString()

    return [
        {
            ke: "family",
            label: FAMILY,
            link: `family?${urlParams}`,
        },
        {
            ke: "scholarity",
            label: "Scholarity",
            link: `scholarity?${urlParams}`,
        },
        {
            ke: "bank",
            label: "Bank",
            link: `bank?${urlParams}`,
        }
    ];
};

const i18n = [
    "std_familly"
];
